import { find } from "lodash/fp";
import { useNavigate } from "react-router-dom";

import Divider from "@mui/material/Divider";

import useIntegrations from "@app/analytics/hooks/integrations/useIntegrations";
import IntegrationItem from "@app/analytics/Integrations/components/IntegrationItem";
import { PROVIDER_CONTENT } from "@app/analytics/Integrations/constants";
import { Detail } from "@app/analytics/Integrations/styles";
import useResponsiveView from "@app/common/hooks/useResponsiveView";

const WorkspaceIntegrations = () => {
  const { workspaceIntegrations } = useIntegrations();
  const navigate = useNavigate();
  const { inDesktopView } = useResponsiveView();

  const selectedProviderId = find(
    { route: location.pathname },
    workspaceIntegrations
  )?.providerId;

  const handleSelectProvider = (route: string) => {
    navigate(route, { replace: inDesktopView });
  };

  return (
    <>
      <Detail>
        These integrations apply to everyone in your Workspace. For example,
        integrating with Slack allows anyone in your Workspace to send report
        summaries to Slack.
      </Detail>
      <Divider sx={{ mx: 1.5 }} />
      {workspaceIntegrations.map((integration) => {
        const description =
          PROVIDER_CONTENT[integration.providerId].workspaceShortDescription;
        return (
          <IntegrationItem
            key={integration.providerId}
            description={description ?? ""}
            provider={integration}
            onClick={handleSelectProvider}
            isSelected={selectedProviderId === integration.providerId}
          />
        );
      })}
      <Divider sx={{ mx: 1.5 }} />
    </>
  );
};

export default WorkspaceIntegrations;
